import React from 'react';
import { Pie } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from 'chart.js';
import { Box, Typography, Card, CardContent } from '@mui/material';

ChartJS.register(ArcElement, Tooltip, Legend);

const TrafficSourcePieChart = ({ data, title = "Distribuição de Origem do Tráfego" }) => {
  // Verificar se dados existem e são válidos
  if (!data || !Array.isArray(data) || data.length === 0) {
    return (
      <Card sx={{ height: 400 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            {title}
          </Typography>
          <Box display="flex" alignItems="center" justifyContent="center" height={300}>
            <Typography color="text.secondary">
              Não há dados disponíveis para exibir
            </Typography>
          </Box>
        </CardContent>
      </Card>
    );
  }

  // Preparar dados para o gráfico
  const chartData = {
    labels: data.map(item => 
      `${item.utm_source || 'organico'} ${item.utm_campaign ? `(${item.utm_campaign})` : ''}`
        .trim()
    ),
    datasets: [
      {
        data: data.map(item => item.total_sales || 0),
        backgroundColor: [
          '#FF6B6B', // Vermelho coral
          '#4ECDC4', // Turquesa
          '#45B7D1', // Azul
          '#96CEB4', // Verde claro
          '#FECA57', // Amarelo
          '#FF9FF3', // Rosa
          '#54A0FF', // Azul claro
          '#FF6348', // Vermelho tomate
          '#1DD1A1', // Verde
          '#C44569', // Rosa escuro
        ],
        borderWidth: 2,
        borderColor: '#fff',
        hoverBorderWidth: 3,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'right',
        align: 'center',
        labels: {
          usePointStyle: true,
          padding: 20,
          font: {
            size: 12,
          },
          generateLabels: (chart) => {
            const data = chart.data;
            if (data.labels.length && data.datasets.length) {
              return data.labels.map((label, i) => {
                const dataset = data.datasets[0];
                const total = dataset.data.reduce((a, b) => a + b, 0);
                const value = dataset.data[i];
                const percentage = ((value / total) * 100).toFixed(1);
                
                return {
                  text: `${label} (${percentage}%)`,
                  fillStyle: dataset.backgroundColor[i],
                  strokeStyle: dataset.borderColor,
                  lineWidth: dataset.borderWidth,
                  pointStyle: 'circle',
                  hidden: false,
                  index: i,
                };
              });
            }
            return [];
          },
        },
      },
      tooltip: {
        callbacks: {
          label: function(context) {
            try {
              const total = context.dataset?.data?.reduce((a, b) => (a || 0) + (b || 0), 0) || 1;
              const parsed = context.parsed || 0;
              const percentage = ((parsed / total) * 100).toFixed(1);
              return `${context.label}: ${parsed.toLocaleString('pt-BR')} vendas (${percentage}%)`;
            } catch (e) {
              return `${context.label}: 0 vendas (0%)`;
            }
          },
        },
      },
    },
  };

  if (!data || data.length === 0) {
    return (
      <Card sx={{ height: 400 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            {title}
          </Typography>
          <Box display="flex" alignItems="center" justifyContent="center" height={300}>
            <Typography color="text.secondary">
              Não há dados disponíveis para exibir
            </Typography>
          </Box>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card sx={{ height: 400 }}>
      <CardContent>
        <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
          {title}
        </Typography>
        <Box height={320}>
          <Pie data={chartData} options={options} />
        </Box>
      </CardContent>
    </Card>
  );
};

export default TrafficSourcePieChart;
